// @ts-strict-ignore
import type { PresentationalToken } from '../../editor/components/mla/types';

export function customizeIEVMLAFootnote({
  processedTokens,
}: {
  processedTokens: PresentationalToken[];
}) {
  let presentationalTokens: PresentationalToken[] = [];
  const tokenIndexes = processedTokens.map(token => {
    const conditionallyLowercaseLabel = token.label === 'Count' ? token.label.toLowerCase() : token.label;
    return {
      ...token,
      label: conditionallyLowercaseLabel,
    };
  });

  presentationalTokens = [
    {
      label: 'The',
      placeholder: 'the-0',
      isOptional: false,
      component: null,
      value: null,
    },
    ...tokenIndexes,
  ];

  const entitiesTokenIndex = presentationalTokens.findIndex(token => token.placeholder === '{entities}');
  if (entitiesTokenIndex > -1) {
    const incomingValue = presentationalTokens[entitiesTokenIndex].value;
    if (incomingValue === 'evaluations_grouped_by_distinct_ssns') {
      presentationalTokens[entitiesTokenIndex].label = 'Evaluations grouped by distinct SSNs';
      presentationalTokens[entitiesTokenIndex].value = null;
      presentationalTokens[entitiesTokenIndex].component = null;
    }
  }

  const intervalTokenIndex = presentationalTokens.findIndex(token => token.placeholder === '{interval}');
  if (intervalTokenIndex > -1) {
    presentationalTokens[intervalTokenIndex].label = presentationalTokens[
      intervalTokenIndex
    ].value as string;
  }

  return presentationalTokens;
}
